module.exports = __webpack_public_path__ + "static/img/recruit.c6310b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/recruit.png
// module id = 70oY
// module chunks = 0